'use client';
import { CommonImage } from '@/components/common';
import { logo_white } from "@/images";
import { setArtistPopup } from '@/redux/actions/common.action';
import { AppDispatch } from '@/redux/store';
import { useDispatch } from 'react-redux';

const ArtistCarousel = ({
  artists,
}: {
  artists: any;
}) => {
  const dispatch = useDispatch<AppDispatch>();

  if (artists && artists.length === 0) return <></>;

  return (
    <div className=''>
      <h2 className='mb-4 text-xl font-bold text-gray-900'>Artists</h2>
      <div className='flex flex-row flex-wrap overflow-x-auto hide-scrollbar gap-6'>
        {artists?.map((artist: any, index: number) => (
          <div
            key={`${artist.artistName}-${index}`}
            className='flex flex-col cursor-pointer'
            onClick={() => dispatch(setArtistPopup(true))}
          >
            {artist.artistImageUrl !== '' && artist.artistImageUrl ? (
              <CommonImage
                src={artist.artistImageUrl || logo_white}
                width={100}
                height={100}
                alt='artist_image'
                className='size-28 rounded-2xl pl-[1px] bg-gray-300 object-fill object-center'
              />
            ) : (
              <div className='size-28 rounded-2xl pl-[1px] bg-gray-300 flex justify-center items-center'>
                <CommonImage
                  width={100}
                  height={100}
                  src={artist.artistImageUrl || logo_white}
                  alt='artist_image'
                />
              </div>
            )}
            <div className='mt-2 flex flex-col'>
              <div className='flex items-center justify-between'>
                <p className='text-base font-semibold px-2'>{artist.artistName}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ArtistCarousel;
